
const LiveStockWidgetItem = () =>
  import('~/components/Finance/LiveStockWidgetItem.vue');

export default {
  fetchOnServer: false,

  components: { LiveStockWidgetItem },

  data() {
    return {
      data: {},
    };
  },

  async fetch() {
    await this.fetchApi();
  },

  computed: {
    indexes() {
      return this.data.indexes;
    },
  },

  methods: {
    async fetchApi() {
      const { data } = await this.$axios.request({
        url: '/front/live/index',
        method: 'get',
      });

      this.data = data;
    },
  },
};
